if (!customElements.get("footer-details")) {
  class FooterDetails extends AccordionDetails {
    constructor() {
      super();
    }
    
    connectedCallback() {
      this.openDefault = this.dataset.openDefault === 'true';

      // Menus stay expanded from 768px up (tablet row + desktop row).
      // They collapse only on small screens.
      if (FoxTheme.config.mqlMobile) {
        if (!this.openDefault) this.open = false;
      }

      document.addEventListener('matchMobile', () => {
        if (!this.openDefault) {
          this.open = false;
        } else {
          this.open = true;
        }
      });

      document.addEventListener('unmatchMobile', () => {
        this.open = true;
      });
    }
  }
  customElements.define('footer-details', FooterDetails, { extends: 'details' });
}

function initFooterTrustSlider() {
  const root = document.querySelector('.shopify-section-group-footer-group .multicolumn-icon');
  if (!root || root.dataset.trustSlider === 'true') return;

  const scroller = root.querySelector('.multicolumn__items');
  const slides = root.querySelectorAll('.multicolumn-card-wrapper');
  const dots = root.querySelectorAll('.multicolumn-icon__dot');
  if (!scroller || slides.length < 2 || !dots.length) return;

  root.dataset.trustSlider = 'true';
  const mobileQuery = window.matchMedia('(max-width: 767px)');

  const setActiveDot = (index) => {
    dots.forEach((dot, dotIndex) => {
      const isActive = dotIndex === index;
      dot.classList.toggle('is-active', isActive);
      if (isActive) {
        dot.setAttribute('aria-current', 'true');
      } else {
        dot.removeAttribute('aria-current');
      }
    });
  };

  const currentIndex = () => {
    const width = scroller.clientWidth;
    if (!width) return 0;
    return Math.max(0, Math.min(slides.length - 1, Math.round(scroller.scrollLeft / width)));
  };

  scroller.addEventListener(
    'scroll',
    () => {
      if (!mobileQuery.matches) return;
      window.requestAnimationFrame(() => setActiveDot(currentIndex()));
    },
    { passive: true }
  );

  dots.forEach((dot) => {
    dot.addEventListener('click', () => {
      const index = Number(dot.dataset.index);
      scroller.scrollTo({ left: index * scroller.clientWidth, behavior: 'smooth' });
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initFooterTrustSlider);
} else {
  initFooterTrustSlider();
}

document.addEventListener('shopify:section:load', initFooterTrustSlider);

document.addEventListener('shopify:block:select', (event) => {
  if (!window.matchMedia('(max-width: 767px)').matches) return;
  const root = document.querySelector('.shopify-section-group-footer-group .multicolumn-icon');
  const scroller = root && root.querySelector('.multicolumn__items');
  const slide = event.target.closest('.multicolumn-card-wrapper');
  if (!root || !scroller || !slide || !root.contains(slide)) return;
  const index = Number(slide.dataset.index);
  scroller.scrollTo({ left: index * scroller.clientWidth, behavior: 'smooth' });
});